export default __webpack_public_path__ + "static/media/sucess.faf4a87a.svg";